import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "svg-icon svg-icon-2"
}
const _hoisted_3 = {
  key: 1,
  class: "spinner-border spinner-border-sm mx-1",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.loading,
    type: "button",
    class: "btn btn-light-success me-3 btn-sm",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePDF && _ctx.generatePDF(...args)))
  }, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr078.svg" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)),
    _createTextVNode(" " + _toDisplayString(_ctx.t("timetable.print")), 1)
  ], 8, _hoisted_1))
}